import styled, { css } from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';
import { media, themed } from '@/shared/ui/core';

const modifiers = {
  info: ({ theme }) => ({
    styles: `
      color: ${theme.primary.text};
      font-weight: 400;
      font-size: 0.6875rem;
      line-height: 0.875rem;
      letter-spacing: 0.0156rem;
      text-transform: uppercase;
    `,
  }),
  bidGuidance: ({ theme }) => ({
    styles: `
      display: flex;
      flex-direction: column;
      font-size: 0.8125rem;
      font-weight: 500;
      letter-spacing: 0.0156rem;
      line-height: 0.875rem;
      margin: auto 0 0;

      span {
        color: ${theme.tabs.inactive};
        font-weight: 400;
        font-size: 0.6875rem;
        line-height: 0.8125rem;
        letter-spacing: 0.0156rem;
        margin-top: 0.175rem;
      }
    `,
  }),
  isFullService: ({ theme }) => ({
    styles: `
      span > span {
        color: ${theme.status.success};
      }
    `,
  }),
  lastCheckboxGroup: () => ({
    styles: `
      @media ${media.tabletMin} {
        flex-direction: row-reverse;
      }
    `,
  }),
};

export const DynamicShift = styled.div`
  margin-top: 0.5rem;
  max-width: 100%;
  width: 100%;

  button {
    span {
      font-weight: 400;
      letter-spacing: 0.00625rem;
      line-height: 1.125rem;
      margin-left: 0.625rem;
    }
  }

  @media ${media.tabletMin} {
    border-top: 1px solid ${themed('primary.lightGray')};
    margin-top: 0.75rem;
    padding-top: 0.5rem;
  }

  .RadioLabel {
    color: ${themed('primary.text')};
    font-weight: 700;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .RadioGroup {
    margin-top: unset;
  }

  .HalfDayNotice {
    margin-bottom: 1rem;
  }
`;

export const FieldsetGroup = styled.div`
  max-width: 100%;

  @media ${media.tabletMin} {
    align-items: flex-end;
    display: flex;
    justify-content: space-between;
  }
`;

export const Fieldset = styled.fieldset`
  border: 0;
  display: block;
  padding: 0.25rem 0 0.5rem;

  & > p:not(p.Label) {
    align-items: flex-start;
    display: flex;
    font-size: 0.875rem;
    gap: 0.25rem;
    line-height: 0.875rem;
    letter-spacing: 0.015rem;
    margin: 0;
  }

  &:last-of-type {
    display: none;
    padding: 0.5rem 0 0.75rem;

    @media ${media.tabletMin} {
      display: unset;
      opacity: 0.5;
      padding: 0.25rem 0 0.5rem;
    }

    ${({ isFullService }) => isFullService
      && css`
        display: unset;

        @media ${media.tabletMin} {
          opacity: 1;
        }
      `}
  }

  && label.component__Checkbox {
    font-size: 0.875rem;
    line-height: 0.875rem;
  }
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: flex-start;

  label.component__Checkbox {
    color: ${themed('primary.text')};
    font-size: 1rem;
    font-weight: 400;
    min-width: 6.5rem;
  }

  @media ${media.tabletMin} {
    gap: 1.15rem;

    label.component__Checkbox {
      min-width: unset;
    }
  }

  ${applyStyleModifiers(modifiers)};
`;

export const Footer = styled.div`
  align-items: flex-end;
  display: flex;
  justify-content: space-between;

  & .ShiftPriceInput {
    margin-left: auto;
  }
`;

export const Label = styled.p.attrs({
  className: 'Label',
})`
  align-self: flex-start;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 0.875rem;
  letter-spacing: 0.015rem;
  margin: 0 0 0.25rem;
  max-width: 16.5rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  ${applyStyleModifiers(modifiers)};
`;
